<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
    :style="backgroundstyle"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <img src="@/assets/img/yourplace/goldlogo.png" />
          </li>
          <span style="padding-left:235px;">
            <!-- <li>
            <router-link to="/">Home</router-link>
          </li>
          <li>
            <router-link to="/locations">Locations</router-link>
          </li>
          <li>
           <router-link to="/aboutus">About Us</router-link>
                
          </li>
          <li>
            <router-link to="/contactus">Contact Us</router-link>
                
          </li> -->
          </span>
          <span class="padfooter" style="">
            <li>
              <router-link to="/"
              >
                <a href="https://www.tiktok.com/@yprealestate?_t=ZS-8xpcvwiATCy&_r=1">
                <svg width="24" height="24" viewBox="0 0 48 48" fill="#bfa46a" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M34 10.5c1.7 1.2 3.7 2 6 2v4.1c-2.7-.1-5.1-.8-7-2.1v13.7c0 6.2-5 11.3-11.2 11.3S10.5 34.4 10.5 28.2c0-6.2 5-11.2 11.2-11.2v4.1c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.1 7.1 7.1 7.1-3.2 7.1-7.1V6.5h4.1c0 1.5.6 2.9 1.6 4z"/>
                </svg>
                </a>
              </router-link>
            </li>
            <li>
              <a
                  href="https://www.linkedin.com/company/your-place-real-estate-investment"
              ><img
                  style="height: 20px;
width: 20px;
left: 2px;
top: 4.001953125px;
border-radius: 0px;
"
                  src="@/assets/img/yourplace/LinkedIn.png"
              /></a>
            </li>
            <li>
              <a href="https://www.facebook.com/share/1BrWdVGeX3/?mibextid=wwXIfr"
              ><img
                  style="height: 20px;
width: 20px;
left: 2px;
top: 4.001953125px;
border-radius: 0px;
"
                  src="@/assets/img/yourplace/Facebook.png"
              /></a>
            </li>
            <li>
              <a
                  href="https://www.instagram.com/yourplaceconsultancy?igsh=MXJsNDRsYzNnamxkMw=="
              ><img
                  style="height: 20px;
width: 20px;
left: 2px;
top: 4.001953125px;
border-radius: 0px;
"
                  src="@/assets/img/yourplace/Instagram.png"
              /></a>
            </li>
<!--            <li>
              <router-link to="/"
              ><img
                  style="height: 20px;
width: 20px;
left: 2px;
top: 4.001953125px;
border-radius: 0px;
"
                  src="@/assets/img/yourplace/YouTube.png"
              /></router-link>
            </li>-->
          </span>
        </ul>
      </nav>
      <!-- <div class="copyright">
        &copy; {{ year }}, made with <md-icon>favorite</md-icon> by
        <a href="https://www.creative-tim.com/" target="_blank">Creative Tim</a>
        for a better web.
      </div> -->
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
    background: {
      type: String,
      default: require("@/assets/img/yourplace/151.png")
    },
    twitter: {
      type: String,
      default: require("@/assets/img/yourplace/Twitter.png")
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {
    backgroundstyle() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  }
};
</script>
<style>
.padfooter {
  padding-left: 450px;
}
@media screen and (max-width: 600px) {
  .padfooter {
    padding-left: 0px;
  }
}
</style>
